import { isServer } from '@utils/isServer'
import axiosFactory, { type InternalAxiosRequestConfig } from 'axios'

import { config } from '../../../config'

// Собираем статистику по запросам
let statData = {}

// Текущий выбранный проект
let currentProject = ''
export const setCurrentProject = (project: string) => (currentProject = project)
export const getCurrentProject = () => currentProject

/**
 * Добавляем необходимые заголовки к запросам
 * Authorization — если пользователь авторизован
 * Evirma-Project — если выбран текущий проект
 */
async function appendHeadersInterceptor(request: InternalAxiosRequestConfig) {
  statData[(request.baseURL ?? '') + (request.url ?? '')] = new Date()

  if (request.headers && currentProject) {
    request.headers.set('Evirma-Project', `${currentProject}`)
  }

  if (isServer()) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { cookies, headers: getHeaders } = require('next/headers')
    const cookieStore = await cookies()
    const headerStore = await getHeaders()

    request.headers.Cookie = cookieStore.toString()
    request.headers['X-Forwarded-For'] = headerStore.get('x-forwarded-for') ?? ''
    request.headers['X-Real-IP'] = headerStore.get('x-real-ip') ?? ''
  }

  return request
}

/****************************************************************************
 * axiosProxy
 ***************************************************************************/
export const axiosProxy = axiosFactory.create({
  withCredentials: true,
  baseURL: isServer() ? config.proxyUrlServer : config.proxyUrlClient,
  //validateStatus: () => true,
  validateStatus: (status) => status >= 200 && status < 300,
  headers: {
    'Content-Type': 'application/json',
    //'User-Agent': 'EvirmaFrontProxy/1.0',
  },
})

axiosProxy.defaults.timeout = 15000
axiosProxy.interceptors.request.use(
  async (request) => appendHeadersInterceptor(request),
  (error) => Promise.reject(error)
)

/****************************************************************************
 * Retry Interceptor for axiosProxy
 ***************************************************************************/
const MAX_RETRIES = 1
const skipRetryHeader = 'X-Evirma-Skip-Retry'

axiosProxy.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config

    // Если нет конфигурации или retry уже превышен — не повторяем
    if (!config || config.headers?.get(skipRetryHeader) === '1' || config.__retryCount >= MAX_RETRIES) {
      console.log('Retry count exceeded')
      return Promise.reject(error)
    }

    // Проверяем, стоит ли повторять запрос
    const status = error.response?.status
    const shouldRetry = !status || (status >= 500 && status < 600) // сетевые и 5xx ошибки

    if (!shouldRetry) {
      return Promise.reject(error)
    }

    // Инициализируем счётчик попыток
    config.__retryCount = (config.__retryCount || 0) + 1

    // Ждём немного перед повтором (например, 1s, 2s, 3s)
    const delay = config.__retryCount * 1000
    await new Promise((resolve) => setTimeout(resolve, delay))

    // Повторяем запрос
    return axiosProxy(config)
  }
)

/****************************************************************************
 * axios
 ***************************************************************************/
export const axios = axiosFactory.create({
  withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_API_BASEURL,
  validateStatus: () => true,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    //'User-Agent': 'EvirmaFront/1.0',
    Pragma: 'no-cache',
    Expires: '0',
  },
})

axios.defaults.timeout = 15000
axios.defaults.timeout = 15000
axios.interceptors.request.use(
  async (request) => appendHeadersInterceptor(request),
  (error) => Promise.reject(error)
)

/****************************************************************************
 * axiosDirect
 ***************************************************************************/
export const axiosDirect = axiosFactory.create({
  withCredentials: true,
  baseURL: config.backendUrl,
  headers: {
    'Content-Type': 'application/json',
    //'User-Agent': 'EvirmaFrontDirect/1.0',
  },
})
